<div class="banner"
  *transloco="let t; lang: 'en|static' read: 'abemcertified_abem_org.banner'">
  <div class="content">
    <div class="banner-top">
      <div class="wrapper">
        <img class="branding-logo"
          src="/assets/themes/abemcertified.abem.org/images/header_logo.png"
          [alt]="t('issuer_logo')">

        <div class="banner-top-text">
          <div class="banner1">
            {{ t('banner1') }}
          </div>

          <a href="https://www.abem.org/public/become-certified/becoming-certified-initiative"
            target="_blank">
            <button mat-button
              class="mat-button-base mat-default mat-focus-indicator mat-stroked-button"
              [attr.aria-label]="t('banner_button')">
              {{ t('banner_button') }}
            </button>
          </a>
        </div>
      </div>
    </div>

    <div class="banner-bottom">
      <div class="wrapper">
        <div class="banner2">
          {{ t('banner2') }}
          <a href="https://www.abem.org/public/about-abem/who-is-abem-certified"
            target="_blank">{{ t('verify_certification') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
